import {LOAD_CCTRANSACTION_DATA, DELETE_A_CCTRANSACTION, SAVE_A_CCTRANSACTION, UPDATE_A_CCTRANSACTION} from './actions';

const initialState = {
  cctransactionsArray:[],
    deleteCctransactionResp:{},
    errorCMsg:{},
    saveCctransactionResp:{},
    updateCctransactionResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case LOAD_CCTRANSACTION_DATA:
          return Object.assign({}, state, {
              cctransactionsArray: action.cctransactionsData
          });
          case DELETE_A_CCTRANSACTION:
          return Object.assign({}, state, {
              deleteCctransactionResp: action.deleteCctransactionResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_CCTRANSACTION:
          return Object.assign({}, state, {
              saveCctransactionResp: action.saveCctransactionResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_CCTRANSACTION:
          return Object.assign({}, state, {
              updateCctransactionResp: action.saveCctransactionResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
